export const getSelectedListVehicleId = (state) => state.listvehicles_and_state.selectedId;
export const getVehicleStateVisible = (state) => state.listvehicles_and_state.vehicleStateVisible;
